import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import React from 'react';
import ButtonDesigned from '../../Buttons/ButtonDesigned';
import { uploadErrorType } from '../fileUploadUtils';

interface Props {
  setDisplayOverlay: (value: boolean) => void;
  errorType?: uploadErrorType;
  hideClose?: boolean;
}

export const AttachFileErrorScreen: React.FC<Props> = ({ setDisplayOverlay, errorType = 'none' }) => {
  return (
    <div className={`fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50`}>
      <div className="flex  flex-col gap-4 py-3 px-6 items-center bg-white border-t-4 border-red w-[24rem] ">
        <div className="text-red ">
          <ErrorOutlineOutlinedIcon style={{ width: 40, height: 40 }} />
        </div>
        <p className="font-medium text-lg">{errorDictionary[errorType].title}</p>
        <p className="text-sm text-secondary_text text-center">{errorDictionary[errorType].value}</p>
        <ButtonDesigned onButtonClick={() => setDisplayOverlay(false)} style="outline" className="py-2 px-4">
          Close
        </ButtonDesigned>
      </div>
    </div>
  );
};

const errorDictionary: Record<uploadErrorType, { title: string; value: string }> = {
  format: { title: 'Upload error', value: 'The file format is not supported by the system.' },
  multi: { title: 'Upload error', value: 'Only one file can be uploaded at a time.' },
  size: { title: 'Upload error', value: 'File size exceeding the limit' },
  upload: { title: 'Upload error', value: 'There was a problem uploading the documents, please try again.' },
  none: { title: 'Upload error', value: 'The system cannot attach the file. please check the file format or size.' },
};
